import { render } from "./datatableProfile.vue?vue&type=template&id=63b3caa9"
import script from "./datatableProfile.vue?vue&type=script&lang=js"
export * from "./datatableProfile.vue?vue&type=script&lang=js"

import "./datatableProfile.vue?vue&type=style&index=0&id=63b3caa9&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__